import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/list/main.css';
import '@fullcalendar/timegrid/main.css';

import { Paper, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { deleteRecord, fetchRecord, postRecord } from '../../services/Axios';

import { COMMON_CODES } from '../../constants/StatusCode';
import { EVENTS } from '../../constants/ApiEndPoint';
import FullCalendar from '@fullcalendar/react';
import Header from './Header';
import PopUp from './PopUp';
import Toolbar from './Toolbar';
import dayGridPlugin from '@fullcalendar/daygrid';
import { getSelectedBooking } from '../../services/Storage';
import listPlugin from '@fullcalendar/list';
import moment from 'moment';
import timeGridPlugin from '@fullcalendar/timegrid';
import timelinePlugin from '@fullcalendar/timeline';


function Calendar(props) {
    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    const code = urlParams.get('code');
    const [reqId, setReqId] = useState('');
    const [selectedEvent, setSelectedEvent] = useState('');
    const { hideHeader,bookingDates,title } = props;

    const calendarRef = useRef(null);
    const theme = useTheme();
    const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
    const [view, setView] = useState(mobileDevice ? 'dayGridMonth' : 'dayGridMonth');
    const [date, setDate] = useState(moment().toDate());
    const [events, setEvents] = useState([]);
    const [event, setEvent] = useState([]);
    const [filters, setFilters] = useState(false);
    const [eventModal, setEventModal] = useState({
        open: false,
        event: null,
    });
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOpen, setIsOpen] = useState(false);

    function getBookingsInMonth() {
        const input = new Date(date);
        const inputMonth = input.getMonth();
        const inputYear = input.getFullYear();

        console.log("events=====>input", inputMonth);
        console.log("events=====>bookingDates", bookingDates);
        return bookingDates.filter(({ startDate, endDate }) => {
          const start = new Date(startDate);
        
          console.log("M=====>C", inputMonth);
          console.log("M=====>T", start.getMonth());
          console.log("M=====>Cy", input);
          console.log("M=====>Ty", start.getFullYear());
          // // Check if the input date falls between start and end
          if (inputMonth == start.getMonth() && inputYear == start.getFullYear()) {
            // Check if the input month is between start and end
             return true;
          }
          return false;
        });
      }
      function countDaysBetween(startDate, endDate) {
        // Convert to date-only (midnight) to avoid time zone/time part issues
        const start = new Date(new Date(startDate).toDateString());
        const end = new Date(new Date(endDate).toDateString());
      
        const diffTime = end - start;
        const diffDays = Math.abs(diffTime / (1000 * 60 * 60 * 24));
      
        return diffDays+1;
      }
      
      function addOneDay(dateStr) {
        const date = new Date(dateStr);
        date.setDate(date.getDate() + 1);
        return date;
      }

    const setEventsFromBookingDates = () => {
        console.log("events=====>y", getBookingsInMonth());
        const events = getBookingsInMonth()?.map((event) => {
            const dayDiff= countDaysBetween(event.startDate, event.endDate);
            return {
                ...event,
                bookingDates:[{...event,days:dayDiff}],
                days:dayDiff,
                start: event.startDate,
                end: addOneDay(event.endDate),
                allDay: true,
                color:"#F5E3A4",
                textColor: "#b9832b",
                type: "booking_request",
                description: event.description,
                title:  title +
                      '\n' +
                      event.taskTypeInfo?.title +
                      '\n' +
                      event.holdTypeInfo.title.split('(')[1].split(')')[0],
                   
                originalTitle: title,
            };
        });
        console.log("mappedEvents=====>1", events);
      setEvents(events);
    }
  
    // useEffect(() => {    
    //     setEventsFromBookingDates();   
    // }, [date]);
        

    const handleEventNew = () => {
        setEventModal({
            open: true,
            event: null,
        });
    };

    const handleEventDelete = async (e) => {
        setEventModal({
            open: false,
            event: null,
        });
        setAnchorEl(null);
        const response = await deleteRecord(EVENTS.DELETE, '', event.id);

        if (response) {
            if (response.status === COMMON_CODES.SUCCESS) {
            }
        }
    };
    const handleEventEdit = (e) => {
        const currentEvent = {
            _id: event.id,
            title: event.title,
            description: event._def.extendedProps.description,
            start: event._def.extendedProps.startDate,
            end: event._def.extendedProps.endDate,
            allDay: event.allDay,
            color: event.backgroundColor,
            generate: event._def.extendedProps.generate,
        };
        setEventModal({
            open: true,
            event: currentEvent,
        });
        setAnchorEl(null);
    };

    const handlePopoverOpen = (info) => {
        if (isOpen) {
            setIsOpen(false);
        }
        setEvent(info.event);
        let { top, left, right } = info.el.getBoundingClientRect();
        let anchorEl = {
            top,
            left,
            right,
        };
        if (left > 200) {
            anchorEl = {
                top: parseInt(top - 80),
                right: parseInt(right - left - 50),
            };
        } else {
            anchorEl = {
                top: parseInt(top - 80),
                left: parseInt(left),
            };
        }
        setAnchorEl(anchorEl);
        setTimeout(() => {
            setIsOpen(true);
        }, 0);
    };

    const handlePopoverClose = () => {
        if (isOpen) {
            setAnchorEl(null);
            setIsOpen(false);
        }
    };

    const open = Boolean(anchorEl);

    const handleDateToday = () => {
        setAnchorEl(null);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.today();
        setDate(calendarApi.getDate());
    };

    const handleViewChange = (newView) => {
        setAnchorEl(null);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.changeView(newView);
        setView(newView);
    };

    const handleDatePrev = () => {
        setAnchorEl(null);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.prev();
        setDate(calendarApi.getDate());
    };

    const handleDateNext = () => {
        setAnchorEl(null);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.next();
        setDate(calendarApi.getDate());
    };

    let params = {
        date: moment(date).format('YYYY-MM-DD'),
    };

    const fetchEvents = async () => {
        let queryParams = '';
        for (const key in params) {
            if (queryParams !== '' && params[key]) {
                queryParams += '&';
            }
            queryParams += params[key] ? key + '=' + encodeURIComponent(params[key]) : '';
        }
        const response = await fetchRecord(EVENTS.LIST, '', '', queryParams);
        console.log("response=====>", response);
        if (response && response.data && response.data) {
            if (response.status === COMMON_CODES.SUCCESS) {
                const events = response.data;
                if(!response.data){
                    setEventsFromBookingDates();
                    return;
                }
                const mappedEvents = events.map((event) => {
                    return {
                        ...event,
                        title: event.bookingDates
                            ? event.title +
                              '\n' +
                              event.taskTypeInfo?.title +
                              '\n' +
                              event.holdTypeInfo.title.split('(')[1].split(')')[0]
                            : event.title,
                        originalTitle: event.title,
                    };
                });
                console.log("mappedEvents=====>", mappedEvents);
               setEvents(mappedEvents);
                setSelectedEvent(getSelectedBooking());
            }
        } else if (response && response.status === COMMON_CODES.NO_RECORDS) {
            setEvents([]);
        }
    };

    const setToken = async (code) => {
        const response = await postRecord(EVENTS.AUTHORIZE, { code: code });
    };
    if (code) {
        setToken(code).then();
    }
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const reqId = urlParams.get('reqId');
        console.log('--reqId-->', reqId);
        setReqId(reqId);
        fetchEvents().then();

        
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const reqId = urlParams.get('reqId');
        console.log('--reqId-->', reqId);
        setReqId(reqId);
       fetchEvents().then();
    }, [date, filters, reqId]);

    return (
        <>
            {!hideHeader && <Header chipVisible={reqId == null ? false : true} booking={selectedEvent} />}

            <Paper
                sx={{ mt: '0.571rem!important', px: '1.143rem', backgroundColor: 'transparent' }}
                elevation={0}
                onClick={handlePopoverClose}
                onScroll={handlePopoverClose}
            >
                <Toolbar
                    date={date}
                    onDateNext={handleDateNext}
                    onDatePrev={handleDatePrev}
                    onDateToday={handleDateToday}
                    onEventAdd={handleEventNew}
                    onViewChange={handleViewChange}
                    view={view}
                />
                <FullCalendar
                    displayEventTime={false}
                    defaultDate={date}
                    defaultView={view}
                    editable
                    eventClick={handlePopoverOpen}
                    events={events}
                    header={false}
                    height={560}
                    contentHeight="auto"
                    plugins={[dayGridPlugin, timeGridPlugin, listPlugin, timelinePlugin]}
                    ref={calendarRef}
                    rerenderDelay={10}
                    selectable
                    weekends
                />
                {open && (
                    <PopUp
                        onDelete={handleEventDelete}
                        onEdit={handleEventEdit}
                        onCancel={handlePopoverClose}
                        event={event}
                        anchorEl={anchorEl}
                        onClick={handlePopoverClose}
                    ></PopUp>
                )}
            </Paper>
        </>
    );
}

export default Calendar;
